
import { ReactNode } from "react";
import { Card } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface LoadingMessageProps {
  children?: ReactNode;
  className?: string;
  label?: string;
  showProgress?: boolean;
  progress?: number;
  progressSteps?: number;
  currentStep?: number;
}

const LoadingMessage = ({ 
  children, 
  className, 
  label,
  showProgress = false,
  progress = 0,
  progressSteps = 0,
  currentStep = 0
}: LoadingMessageProps) => {
  // Calculate progress percentage if using steps
  const calculatedProgress = progressSteps > 0 
    ? Math.min(100, Math.round((currentStep / progressSteps) * 100)) 
    : progress;
  
  return (
    <Card className={`p-4 ${className || ''} animate-fade-in`}>
      <div className="flex items-center gap-3 mb-2">
        <div className="relative">
          <Loader2 className="h-4 w-4 animate-spin text-primary" />
          <div className="absolute inset-0 animate-ping opacity-30 rounded-full bg-primary" style={{ animationDuration: '3s' }}></div>
        </div>
        {children || (
          <span className="text-sm text-muted-foreground">
            {label || "Processing..."}
          </span>
        )}
      </div>
      
      {showProgress && (
        <div className="space-y-1">
          <Progress 
            value={calculatedProgress} 
            className="h-1 mt-2" 
            aria-label="Processing progress"
          />
          {progressSteps > 0 && (
            <div className="text-xs text-muted-foreground text-right">
              Step {currentStep} of {progressSteps}
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default LoadingMessage;
